import {Badge} from "inferno-bootstrap";
import {Level} from "../../../../utils/types";

export function NotificationBody(props: { message?: string, timestamp?: string, level?: Level }) {
	const level = props.level || Level.Primary;
	let message = "";
	if (props.timestamp && props.message) {
		message = props.timestamp + ": " + props.message;
	} else {
		message = props.timestamp || props.message;
	}

	return (
		<Badge pill color={level}>
			<small>{message}</small>
		</Badge>
	);
}
